// extracted by mini-css-extract-plugin
export default {"user-statistic-list":"UserStatisticList_user-statistic-list__4vv22","user-statistic-list__reset":"UserStatisticList_user-statistic-list__reset__3y4yu"};